<template>
  <div class="app">
    <AppHeader />
    <div class="app-body">
      <Sidebar :nav-items="navItems" />
      <main class="main">
        <div :style="{ backgroundColor: sfondoBody }">&nbsp;</div>
        <!-- style="background-color: #D7E4F2" -->
        <!-- <breadcrumb :list="list"/> -->
        <div class="container-fluid" :style="{ backgroundColor: sfondoBody, height: '100%' }">
          <!-- style="background-color: #D7E4F2;height:100%" -->
          <router-view></router-view>
        </div>
      </main>
      <AppAside />
    </div>
    <!--<AppFooter/>-->
  </div>
</template>

<script>
// import nav from "../_nav";
// import menuService from "../services/backend/menuService";
import {
  Header as AppHeader,
  Sidebar,
  Aside as AppAside /*,
  Footer as AppFooter,
  Breadcrumb*/
} from "../components/";
// import jsonHelper from "../shared/jsonHelper";
import { mapGetters } from "vuex";
// import dashboardService from "../services/backend/dashboardService";
import generalService from "../services/backendCipriani/generalService";
import colorsService from "../services/backend/colorsService";
//import projectService from "../services/backend/projectService";

export default {
  name: "Full",
  components: {
    AppHeader,
    Sidebar,
    AppAside /*,
    AppFooter,
    Breadcrumb*/
  },
  data() {
    return {
      navFromServer: [],
      //navFromProjects: [],
      appsList: [],
      coloreSfondo: "",
      sfondoBody: ""
    };
  },
  computed: {
    ...mapGetters(["projects"]),
    navItems: function() {
      var ret = [];

      ret.push({
        name: "S626",
        title: true
      });

      this.navFromServer.forEach(element => ret.push(element));

      ret.push({
        divider: true
      });

      /*
      ret.push({
        name: "S1146",
        title: true
      });

      //Andrea => Visualizzo solo gli ultimi 5!
      //this.navFromProjects.forEach(element => ret.push(element));
      var listShow = this.navFromProjects.slice(0, 5);
      listShow.forEach(element => ret.push(element));
      */

      return ret;
    }
    /*name () {
      return this.$route.name
    },
    list () {
      return this.$route.matched
    },*/
  },
  mounted: function() {
    var that = this;
    //colorsService.getColoriCard().then(function(data) {
    var colorList = colorsService.getColoriCard();
    that.coloreSfondo = colorList[0] + " !important";
    //});
    //colorsService.getColoriBody().then(function(data) {
    var colorListB = colorsService.getColoriBody();
    that.sfondoBody = colorListB[0];
    //});
    generalService.getApps().then(function(data) {
      data.forEach(app => {
        app.modalities.forEach(modality => {
          that.appsList.push({
            id: modality.id,
            name: app.name + ", " + that.uniTranslation(modality.name)
          });
        });
      });

      //alert(JSON.stringify(that.appsList));

      // DIFFERENTE PER CIPRIANI
      generalService.getMenuItems().then(function(data) {
        that.navFromServer = data;
      });

      /*
      that.refreshProjects();

      that.$store.subscribe(function(mutation , state) {
        if (mutation.type === "loadProject" || mutation.type === "removeProject") {
          that.refreshProjects();
        }
      });
      */
    });
  },
  methods: {
    getMessage: function(key) {
      return this.uniTranslation(key);
    }
    /*
    refreshProjects: async function() {
      var dbProjects = [];
      await projectService.listProjects().then(list => {
        dbProjects = list;
      });
      var that = this;
      let resPrjs = [];
      let project = that.projects;
      let prjs = {};
      for (let el in project) {
        prjs = project[el];
        if (prjs) {
          resPrjs.push(prjs);
        }
      }
      resPrjs = resPrjs.reverse();
      that.navFromProjects = [];
      resPrjs.forEach(prj => {
        if (prj.modality != undefined) {
          var modStr = that.appsList.find(el => el.id == prj.modality).name;
          var isPresent = dbProjects.find(el => el.projectId == prj.projectId);
          if (isPresent) {
            that.navFromProjects.push({
              name: prj.name,
              state: {
                name: "ViewProject",
                params: {
                  modality: prj.modality,
                  projectId: prj.projectId
                }
              },
              icon: "fa fa-file-text",
              badge: { text: modStr, variant: "secondary" },
              modality: prj.modality,
              projectId: prj.projectId
            });
          }
        }
      });
    }*/
  }
};
</script>

<style>
.el-input__icon {
  line-height: 16px !important;
}
</style>
